export default __webpack_public_path__ + "static/media/8.fa9effb8.svg";